<template>
  <div :class="_.timer">
    <template v-if="countdownInfo.isMoreThan24Hours">
      <div :class="_.item">{{ countdownInfo.diffDays.d }}</div>
      <div :class="_.unit">天</div>
      <div :class="_.item">
        {{ countdownInfo.diffDays.h }}
      </div>
      <div :class="_.unit">小时</div>
    </template>
    <template v-else>
      <div :class="_.item">{{ countdownInfo.diff.h }}</div>
      <div :class="_.divider" />
      <div :class="_.item">{{ countdownInfo.diff.i }}</div>
      <div :class="_.divider" />
      <div :class="_.item">{{ countdownInfo.diff.s }}</div>
    </template>
  </div>
</template>

<script>
  import { computed } from '@vue/composition-api'
  import { defineClassComponent } from '@/hooks'
  import { goodsProvider } from '../provider'

  export default defineClassComponent(
    () =>
      class {
        // 商品数据
        goodsData = goodsProvider.inject()

        // 倒计时信息
        countdownInfo = computed(
          () => this.goodsData.value.discountCountdownInfo,
        )
      },
  )
</script>

<style lang="scss" module>
  .timer {
    display: flex;
    align-items: center;
    color: white;

    .item {
      width: 20px;
      height: 24px;
      background: rgba(#000000, 0.8);
      border-radius: 2px;
      font-size: 18px;
      font-family: Bebas-Regular;
      color: currentColor;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .divider {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('./images/折扣倒计时冒号.png');
      width: 3px;
      height: 16px;
      margin: 0 6px;
    }

    .unit {
      font-size: 12px;
      font-weight: var(--bold-value);
      color: #684700;
      line-height: 17px;
      margin: 0 6px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
